import CONCIERGE_STATES from 'constants/conciergeStates';
import CONCIERGE_MESSAGE_RECEIVED_KEY from 'constants/conciergeMessageReceivedKey';

function init(app) {
  if (!app) throw new Error('app is required');

  app.constant('conciergeState', CONCIERGE_STATES);
  app.constant('conciergeMessageReceivedKey', CONCIERGE_MESSAGE_RECEIVED_KEY);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/constants/index.js